<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatus class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatus class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
        </div>
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown11" :series="switchDataDown11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown12" :series="switchDataDown12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown13" :series="switchDataDown13" />
          <SwitchStatus class="switch-item" :title="switchTitleDown14" :series="switchDataDown14" />
          <SwitchStatus class="switch-item" :title="switchTitleDown15" :series="switchDataDown15" />
          <SwitchStatus class="switch-item" :title="switchTitleDown16" :series="switchDataDown16" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown17" :series="switchDataDown17" />
        </div>
      </div>
      <div class="main-column-multi-line">
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
          <SwitchStatus class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
        </div>
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown2" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown21" :series="switchDataDown21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown22" :series="switchDataDown22" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown23" :series="switchDataDown23" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown24" :series="switchDataDown24" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown25" :series="switchDataDown25" />
        </div>
      </div>
      <div class="main-column-large">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
        <SwitchStatus class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
        <SwitchStatus class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
        <SwitchStatus class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
        <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
        <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
        <SwitchStatus class="switch-item" :title="switchTitleTop39" :series="switchDataTop39" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop310" :series="switchDataTop310" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop311" :series="switchDataTop311" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop312" :series="switchDataTop312" />
      </div>
      <div class="main-column-small">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
      </div>
      <div class="main-column">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop5" :bold="true" />
        <!-- <SwitchStatus class="switch-item" :title="switchTitleTop51" :series="switchDataTop51" /> -->
        <SwitchStatus class="switch-item" :title="switchTitleTop52" :series="switchDataTop52" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop53" :series="switchDataTop53" />
        <SwitchStatus class="switch-item" :title="switchTitleTop54" :series="switchDataTop54" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop55" :series="switchDataTop55" />
      </div>
      <div class="main-column-small">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop6" :bold="true" />
      </div>
      <div class="main-column-small">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop7" :bold="true" />
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>
    
    <script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationLocation: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",

      columnTitleTop1: "前置过滤段",
      columnTitleTop2: "前置表冷段",
      // columnTitleTop3: "除湿段",
      columnTitleTop4: "后置表冷段",
      columnTitleTop5: "送风段",
      columnTitleTop6: "后置过滤段",
      columnTitleTop7: "送风出口",
      columnTitleDown1: "控制箱",
      // columnTitleDown2: "环境",

      switchDataTop11: null,
      switchDataTop12: null,
      switchDataTop13: null,

      switchDataDown11: null,
      switchDataDown12: null,
      switchDataDown13: null,
      switchDataDown14: null,
      switchDataDown15: null,
      switchDataDown16: null,
      switchDataDown17: null,

      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,

      switchDataDown21: null,
      switchDataDown22: null,
      switchDataDown23: null,
      switchDataDown24: null,
      switchDataDown25: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,
      switchDataTop39: null,
      switchDataTop310: null,
      switchDataTop311: null,
      switchDataTop312: null,

      switchDataTop51: null,
      switchDataTop52: null,
      switchDataTop53: null,
      switchDataTop54: null,
      switchDataTop55: null,

      warningFlagLeft: "",
      warningFlagRight: "",
      deviceList: [],
      singlePieHistogramWrapData1: null,
      singlePieHistogramWrapData2: null,
      singlePieHistogramWrapData3: null,
      singlePieHistogramWrapData4: null,
      warningFlag1: "",
      warningFlag2: "",
      warningFlag3: "",
      warningFlag4: "",
      humidityLineData: null,
      humidityBarData: null,

      runningTimeDataLeft: null,
      runningTimeDataRight: null,
    };
  },
  computed: {
    columnTitleTop3: function () {
      return this.stationLocation + this.stationIndex + "站再生除湿段";
    },
    columnTitleDown2: function () {
      return this.stationLocation + this.stationIndex + "站环境";
    },
    switchTitleTop11: function () {
      return "新风温度";
    },
    switchTitleTop12: function () {
      return "新风初效压差";
    },
    switchTitleTop13: function () {
      return "混合中效压差";
    },

    switchTitleDown11: function () {
      return "控制区域湿度";
    },
    switchTitleDown12: function () {
      return "控制区域温度";
    },
    switchTitleDown13: function () {
      return "采集电流";
    },
    switchTitleDown14: function () {
      return "除湿机报警";
    },
    switchTitleDown15: function () {
      return "电源故障";
    },
    switchTitleDown16: function () {
      return "脱扣器";
    },
    switchTitleDown17: function () {
      return "脱扣器";
    },

    switchTitleTop21: function () {
      return "电磁阀霜化";
    },
    switchTitleTop22: function () {
      return "电磁阀霜化";
    },
    switchTitleTop23: function () {
      return "前表";
    },
    switchTitleTop24: function () {
      return "前表";
    },

    switchTitleDown21: function () {
      return this.stationLocation + "柱(1#)";
    },
    switchTitleDown22: function () {
      return this.stationLocation + "柱上(2#)";
    },
    switchTitleDown23: function () {
      return this.stationLocation + "柱中(3#)";
    },
    switchTitleDown24: function () {
      return this.stationLocation + "柱下(4#)";
    },
    switchTitleDown25: function () {
      return "湿度最大值";
    },

    switchTitleTop31: function () {
      return "再生加热";
    },
    switchTitleTop32: function () {
      return "再生排风";
    },
    switchTitleTop33: function () {
      return "再生进风";
    },
    switchTitleTop34: function () {
      return "再生运行";
    },
    switchTitleTop35: function () {
      return "再生超温保护";
    },
    switchTitleTop36: function () {
      return "再生风机";
    },
    switchTitleTop37: function () {
      return "再生加热";
    },
    switchTitleTop38: function () {
      return "再生箱";
    },
    switchTitleTop39: function () {
      return "减速机";
    },
    switchTitleTop310: function () {
      return "转轮计数";
    },
    switchTitleTop311: function () {
      return "再生转轮";
    },
    switchTitleTop312: function () {
      return "再生加热";
    },

    switchTitleTop51: function () {
      return "主风机缺风";
    },
    switchTitleTop52: function () {
      return "主风机";
    },
    switchTitleTop53: function () {
      return "主风机";
    },
    switchTitleTop54: function () {
      return "送风风机";
    },
    switchTitleTop55: function () {
      return "送风风机";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationId = configJson[routerName].stationId;
      this.stationLocation = configJson[routerName].stationLocation;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        const switchIdTop11 = this.findDeviceId(this.switchTitleTop11);
        const switchIdTop12 = this.findDeviceId(this.switchTitleTop12 + "报警");
        const switchIdTop13 = this.findDeviceId(this.switchTitleTop13 + "报警");
        this.switchDataTop11 = {
          data: currentData[switchIdTop11].value,
          isError: currentData[switchIdTop11].errorLevel,
          unit: "℃",
        };
        this.switchDataTop12 = {
          data: currentData[switchIdTop12].value,
          isError: currentData[switchIdTop12].errorLevel,
          isZh: true,
          textOn: "报警",
        };
        this.switchDataTop13 = {
          data: currentData[switchIdTop13].value,
          isError: currentData[switchIdTop13].errorLevel,
          isZh: true,
          textOn: "报警",
        };

        const switchIdDown11 = this.findDeviceId("除湿机" + this.switchTitleDown11);
        const switchIdDown12 = this.findDeviceId("除湿机" + this.switchTitleDown12);
        const switchIdDown13 = this.findDeviceId("除湿机" + this.switchTitleDown13);
        const switchIdDown14 = this.findDeviceId(this.switchTitleDown14);
        const switchIdDown15 = this.findDeviceId(this.switchTitleDown15);
        const switchIdDown16 = this.findDeviceId(this.switchTitleDown16);
        const switchIdDown17 = this.findDeviceId(this.switchTitleDown17 + "运行时间");

        this.switchDataDown11 = {
          data: currentData[switchIdDown11].value,
          isError: currentData[switchIdDown11].errorLevel,
          unit: "%",
        };
        this.switchDataDown12 = {
          data: currentData[switchIdDown12].value,
          isError: currentData[switchIdDown12].errorLevel,
          unit: "℃",
        };
        this.switchDataDown13 = {
          data: currentData[switchIdDown13].value,
          isError: currentData[switchIdDown13].errorLevel,
          unit: "A",
        };
        this.switchDataDown14 = {
          data: currentData[switchIdDown14].value,
          isError: currentData[switchIdDown14].errorLevel,
          isZh: true,
        };
        this.switchDataDown15 = {
          data: currentData[switchIdDown15].value,
          isError: currentData[switchIdDown15].errorLevel,
          isZh: true,
        };
        this.switchDataDown16 = {
          data: currentData[switchIdDown16].value,
          isError: currentData[switchIdDown16].errorLevel,
        };
        this.switchDataDown17 = {
          data: currentData[switchIdDown17].value,
          isError: currentData[switchIdDown17].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop21 = this.findDeviceId("前表" + this.switchTitleTop21);
        const switchIdTop22 = this.findDeviceId("前表" + this.switchTitleTop22 + "运行时间");
        const switchIdTop23 = this.findDeviceId(this.switchTitleTop23 + "开关");
        const switchIdTop24 = this.findDeviceId(this.switchTitleTop24 + "运行时间");

        this.switchDataTop21 = {
          data: currentData[switchIdTop21].value,
          isError: currentData[switchIdTop21].errorLevel,
        };
        this.switchDataTop22 = {
          data: currentData[switchIdTop22].value,
          isError: currentData[switchIdTop22].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop23 = {
          data: currentData[switchIdTop23].value,
          isError: currentData[switchIdTop23].errorLevel,
        };
        this.switchDataTop24 = {
          data: currentData[switchIdTop24].value,
          isError: currentData[switchIdTop24].errorLevel,
          isRunningTime: true,
        };

        const switchIdDown21T = this.findDeviceId("1#传感器温度");
        const switchIdDown21H = this.findDeviceId("1#传感器湿度");
        const switchIdDown22T = this.findDeviceId("2#传感器温度");
        const switchIdDown22H = this.findDeviceId("2#传感器湿度");
        const switchIdDown23T = this.findDeviceId("3#传感器温度");
        const switchIdDown23H = this.findDeviceId("3#传感器湿度");
        const switchIdDown24T = this.findDeviceId("4#传感器温度");
        const switchIdDown24H = this.findDeviceId("4#传感器湿度");
        const switchIdDown25 = this.findDeviceId("1-4#传感器" + this.switchTitleDown25);

        this.switchDataDown21 = [
          {
            data: currentData[switchIdDown21H].value,
            isError: currentData[switchIdDown21H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdDown21T].value,
            isError: currentData[switchIdDown21T].errorLevel,
            unit: "℃",
          },
        ];
        this.switchDataDown22 = [
          {
            data: currentData[switchIdDown22H].value,
            isError: currentData[switchIdDown22H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdDown22T].value,
            isError: currentData[switchIdDown22T].errorLevel,
            unit: "℃",
          },
        ];
        this.switchDataDown23 = [
          {
            data: currentData[switchIdDown23H].value,
            isError: currentData[switchIdDown23H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdDown23T].value,
            isError: currentData[switchIdDown23T].errorLevel,
            unit: "℃",
          },
        ];
        this.switchDataDown24 = [
          {
            data: currentData[switchIdDown24H].value,
            isError: currentData[switchIdDown24H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdDown24T].value,
            isError: currentData[switchIdDown24T].errorLevel,
            unit: "℃",
          },
        ];
        this.switchDataDown25 = {
          data: currentData[switchIdDown25].value,
          isError: currentData[switchIdDown25].errorLevel,
          unit: "%",
        };

        const switchIdTop31 = this.findDeviceId(this.switchTitleTop31 + "温度");
        const switchIdTop32 = this.findDeviceId(this.switchTitleTop32 + "温度");
        const switchIdTop33 = this.findDeviceId(this.switchTitleTop33 + "温度");
        const switchIdTop33B = this.findDeviceId(this.switchTitleTop33 + "风压");
        const switchIdTop34 = this.findDeviceId(this.switchTitleTop34.replace("运行", "转轮运行"));
        const switchIdTop34B = this.findDeviceId(this.switchTitleTop34.replace("运行", "加热运行"));
        const switchIdTop35 = this.findDeviceId(this.switchTitleTop35.replace("超温", "排风超温"));
        const switchIdTop35B = this.findDeviceId(this.switchTitleTop35.replace("超温", "加热超温"));
        const switchIdTop36 = this.findDeviceId(this.switchTitleTop36 + "过载");
        const switchIdTop37 = this.findDeviceId(this.switchTitleTop37 + "干保护");
        const switchIdTop38 = this.findDeviceId(this.switchTitleTop38 + "超温报警");
        const switchIdTop39 = this.findDeviceId(this.switchTitleTop39 + "过载");
        const switchIdTop310 = this.findDeviceId(this.switchTitleTop310);
        const switchIdTop311 = this.findDeviceId(this.switchTitleTop311 + "运行时间");
        const switchIdTop312 = this.findDeviceId(this.switchTitleTop312 + "运行时间");
        this.switchDataTop31 = {
          data: currentData[switchIdTop31].value,
          isError: currentData[switchIdTop31].errorLevel,
          unit: "℃",
        };
        this.switchDataTop32 = {
          data: currentData[switchIdTop32].value,
          isError: currentData[switchIdTop32].errorLevel,
          unit: "℃",
        };
        this.switchDataTop33 = [
          {
            data: currentData[switchIdTop33].value,
            isError: currentData[switchIdTop33].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop33B].value,
            isError: currentData[switchIdTop33B].errorLevel,
            unit: "Pa",
          },
        ];
        this.switchDataTop34 = [
          {
            data: currentData[switchIdTop34].value,
            isError: currentData[switchIdTop34].errorLevel,
            textOn: "转轮",
          },
          {
            data: currentData[switchIdTop34B].value,
            isError: currentData[switchIdTop34B].errorLevel,
            textOn: "加热",
          },
        ];
        this.switchDataTop35 = [
          {
            data: currentData[switchIdTop35].value,
            isError: currentData[switchIdTop35].errorLevel,
            isZh: true,
            textOn: "排风",
          },
          {
            data: currentData[switchIdTop35B].value,
            isError: currentData[switchIdTop35B].errorLevel,
            isZh: true,
            textOn: "加热",
          },
        ];
        this.switchDataTop36 = {
          data: currentData[switchIdTop36].value,
          isError: currentData[switchIdTop36].errorLevel,
          isZh: true,
          textOn: "过载",
        };
        this.switchDataTop37 = {
          data: currentData[switchIdTop37].value,
          isError: currentData[switchIdTop37].errorLevel,
          isZh: true,
          textOn: "干保护",
        };
        this.switchDataTop38 = {
          data: currentData[switchIdTop38].value,
          isError: currentData[switchIdTop38].errorLevel,
          isZh: true,
          textOn: "超温",
        };
        this.switchDataTop39 = {
          data: currentData[switchIdTop39].value,
          isError: currentData[switchIdTop39].errorLevel,
          isZh: true,
          textOn: "过载",
        };
        this.switchDataTop310 = {
          data: currentData[switchIdTop310].value,
          isError: currentData[switchIdTop310].errorLevel,
          unit: "圈",
        };
        this.switchDataTop311 = {
          data: currentData[switchIdTop311].value,
          isError: currentData[switchIdTop311].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop312 = {
          data: currentData[switchIdTop312].value,
          isError: currentData[switchIdTop312].errorLevel,
          isRunningTime: true,
        };

        // const switchIdTop51 = this.findDeviceId(this.switchTitleTop51 + "保护");
        const switchIdTop52 = this.findDeviceId(this.switchTitleTop52 + "运行");
        const switchIdTop52B = this.findDeviceId(this.switchTitleTop52 + "缺风保护");
        const switchIdTop53 = this.findDeviceId(this.switchTitleTop53 + "运行时间");
        const switchIdTop54 = this.findDeviceId(this.switchTitleTop54 + "运行");
        const switchIdTop55 = this.findDeviceId(this.switchTitleTop55 + "运行时间");

        // this.switchDataTop51 = {
        //   data: currentData[switchIdTop51].value,
        //   isError: currentData[switchIdTop51].errorLevel,
        //   isZh: true,
        //   textOn: "保护",
        // };
        this.switchDataTop52 = [
          {
            data: currentData[switchIdTop52B].value,
            isError: currentData[switchIdTop52B].errorLevel,
            isZh: true,
            textOn: "缺风",
          },
          {
            data: currentData[switchIdTop52].value,
            isError: currentData[switchIdTop52].errorLevel,
          },
        ];
        this.switchDataTop53 = {
          data: currentData[switchIdTop53].value,
          isError: currentData[switchIdTop53].errorLevel,
          isRunningTime: true,
        };
        this.switchDataTop54 = {
          data: currentData[switchIdTop54].value,
          isError: currentData[switchIdTop54].errorLevel,
        };
        this.switchDataTop55 = {
          data: currentData[switchIdTop55].value,
          isError: currentData[switchIdTop55].errorLevel,
          isRunningTime: true,
        };
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 7 + 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-multi-line {
    width: calc(100% / 7 + 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-column-multi-line-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }
}
</style>
    